/**
 * Hardcoded mock data for dev tools as something like faker-js was considered too much bloat for the overall bundle size.
 * Eventually we could consider reintroducing it if we make sure its excluded from the production build.
 */

export const MOCK_FIRST_NAMES = [
  'Emma',
  'Liam',
  'Olivia',
  'Noah',
  'Ava',
  'Oliver',
  'Sophia',
  'James',
  'Isabella',
  'William',
  'Charlotte',
  'Lucas',
  'Amelia',
  'Benjamin',
  'Mia',
  'Henry',
  'Harper',
  'Alexander',
  'Evelyn',
  'Sebastian',
  'Abigail',
  'Jack',
  'Emily',
  'Michael',
  'Elizabeth',
  'Daniel',
  'Sofia',
  'Matthew',
  'Avery',
  'Samuel',
  'Ella',
  'David',
  'Scarlett',
  'Joseph',
  'Grace',
  'Carter',
  'Chloe',
  'Owen',
  'Victoria',
  'Wyatt',
  'Riley',
  'John',
  'Aria',
  'Dylan',
  'Lily',
  'Luke',
  'Zoey',
  'Gabriel',
  'Hannah',
  'Anthony',
];

export const MOCK_LAST_NAMES = [
  'Smith',
  'Johnson',
  'Williams',
  'Brown',
  'Jones',
  'Garcia',
  'Miller',
  'Davis',
  'Rodriguez',
  'Martinez',
  'Hernandez',
  'Lopez',
  'Gonzalez',
  'Wilson',
  'Anderson',
  'Thomas',
  'Taylor',
  'Moore',
  'Jackson',
  'Martin',
  'Lee',
  'Thompson',
  'White',
  'Harris',
  'Sanchez',
  'Clark',
  'Ramirez',
  'Lewis',
  'Robinson',
  'Walker',
  'Young',
  'Allen',
  'King',
  'Wright',
  'Scott',
  'Torres',
  'Nguyen',
  'Hill',
  'Flores',
  'Green',
  'Adams',
  'Nelson',
  'Baker',
  'Hall',
  'Rivera',
  'Campbell',
  'Mitchell',
  'Carter',
  'Roberts',
  'Turner',
];

export const MOCK_COMPANY_NAMES = [
  'TechVision Solutions',
  'Global Dynamics Corp',
  'Innovate Systems',
  'NextGen Technologies',
  'Digital Horizons',
  'Apex Industries',
  'Summit Enterprises',
  'Pioneer Group',
  'Velocity Solutions',
  'Quantum Services',
  'Fusion Consulting',
  'Strategic Partners Ltd',
  'Catalyst Innovations',
  'Momentum Capital',
  'Zenith Corporation',
  'Atlas Holdings',
  'Nexus Networks',
  'Meridian Group',
  'Cornerstone Solutions',
  'Pinnacle Systems',
  'Visionary Tech',
  'Synergy Enterprises',
  'Precision Services',
  'Eclipse Solutions',
  'Horizon Ventures',
  'Prime Innovations',
  'Stellar Technologies',
  'Beacon Industries',
  'Vertex Solutions',
  'Proactive Systems',
];

export const MOCK_CITIES = [
  'Amsterdam',
  'Rotterdam',
  'Utrecht',
  'Eindhoven',
  'Groningen',
  'Tilburg',
  'Almere',
  'Breda',
  'Nijmegen',
  'Haarlem',
  'Arnhem',
  'Zaanstad',
  'Amersfoort',
  'Apeldoorn',
  'Enschede',
  'Hoofddorp',
  'Maastricht',
  'Leiden',
  'Dordrecht',
  'Zoetermeer',
  'Zwolle',
  'Deventer',
  'Delft',
  'Alkmaar',
  'Heerlen',
];

export const MOCK_LOCATION_SUFFIXES = ['HQ', 'Branch', 'Office', 'Store'];

export const MOCK_DEPARTMENTS = [
  'Sales',
  'Marketing',
  'Human Resources',
  'Finance',
  'Operations',
  'Customer Service',
  'IT Support',
  'Product Development',
  'Quality Assurance',
  'Logistics',
  'Procurement',
  'Research',
  'Administration',
  'Security',
  'Maintenance',
  'Legal',
  'Communications',
  'Training',
  'Analytics',
  'Business Development',
];

export const MOCK_JOB_TITLES = [
  'Sales Representative',
  'Marketing Manager',
  'HR Specialist',
  'Financial Analyst',
  'Operations Coordinator',
  'Customer Support Agent',
  'IT Administrator',
  'Software Developer',
  'Quality Inspector',
  'Warehouse Manager',
  'Purchasing Agent',
  'Research Analyst',
  'Office Administrator',
  'Security Officer',
  'Maintenance Technician',
  'Legal Advisor',
  'Communications Specialist',
  'Training Coordinator',
  'Data Analyst',
  'Business Consultant',
  'Project Manager',
  'Team Leader',
  'Account Manager',
  'Product Manager',
  'Operations Manager',
];

export const MOCK_PHONE_NUMBER = '+31101234567';

export const MOCK_ESTIMATED_USERS = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

export const MOCK_SHIFT_TIMES = [
  { starttime: '07:00:00', endtime: '15:00:00' },
  { starttime: '09:00:00', endtime: '17:30:00' },
  { starttime: '12:00:00', endtime: '20:00:00' },
  { starttime: '16:00:00', endtime: '23:00:00' },
];

export const MOCK_SHIFT_TEMPLATES = [
  { name: 'Ms', long_name: 'Morning shift', starttime: '07:00:00', endtime: '15:00:00' },
  { name: 'Ds', long_name: 'Day shift', starttime: '09:00:00', endtime: '17:30:00' },
  { name: 'As', long_name: 'Afternoon shift', starttime: '12:00:00', endtime: '20:00:00' },
  { name: 'Es', long_name: 'Evening shift', starttime: '16:00:00', endtime: '23:00:00' },
  { name: 'Ns', long_name: 'Night shift', starttime: '23:00:00', endtime: '07:00:00' },
];

export const MOCK_TIMESHEET_NOTES = [
  '',
  '',
  'Stayed late to finish inventory',
  'Covered for a colleague',
  'Busy shift, extra cleaning',
  'Quiet day',
  'Training a new colleague',
];

export const MOCK_ABSENCE_NOTES = [
  '',
  '',
  'Family visit',
  'Doctor appointment',
  'Moving house',
  'Long weekend away',
  'Not feeling well',
];

/**
 * Helper function to get a random element from an array
 */
export function getRandomElement<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}

/**
 * Helper function to get a random integer between min and max (both inclusive)
 */
export function getRandomIntBetween(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Helper function to pick a random value, where each value's chance is
 * proportional to its weight
 */
export function randomWeightedValue<T>(weightedValues: { value: T; weight: number }[]): T {
  const totalWeight = weightedValues.reduce((weightSum, weighted) => weightSum + weighted.weight, 0);
  let remaining = Math.random() * totalWeight;

  for (const weighted of weightedValues) {
    remaining -= weighted.weight;
    if (remaining <= 0) {
      return weighted.value;
    }
  }

  return weightedValues[weightedValues.length - 1].value;
}

/**
 * Helper function to shuffle an array (Fisher-Yates) without mutating the input
 */
export function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];

  for (let currentIndex = shuffled.length - 1; currentIndex > 0; currentIndex--) {
    const swapIndex = Math.floor(Math.random() * (currentIndex + 1));
    [shuffled[currentIndex], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[currentIndex]];
  }

  return shuffled;
}

/**
 * Helper function to generate a mock email from first and last name
 */
export function generateMockEmail(firstName: string, lastName: string): string {
  return `${firstName.toLowerCase()}.${lastName.toLowerCase()}@example.com`;
}

/**
 * Helper function to generate a unique email by checking against existing emails
 * and appending a UUID suffix if the email already exists
 */
export function generateUniqueEmail(firstName: string, lastName: string, existingEmails: Set<string>): string {
  const baseEmail = generateMockEmail(firstName, lastName);

  if (!existingEmails.has(baseEmail)) {
    return baseEmail;
  }

  // Generate a simple UUID-like suffix using random hex
  const uniqueSuffix = crypto.randomUUID().split('-')[0];
  const emailParts = baseEmail.split('@');
  return `${emailParts[0]}.${uniqueSuffix}@${emailParts[1]}`;
}
